import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import useCrossWindowState from '@/hooks/domain/useCrossWindowState';
import LoadingLayout from '@/layouts/LoadingLayout';

// We don't have real DTO yet – use any for now
export type HelpScoutResponse = {
  success: boolean;
  workspaceAlias: string;
};

const HelpScoutRedirect = () => {
  const [, setRedirect] = useCrossWindowState<HelpScoutResponse | null>(
    'helpscout-redirect',
    null,
  );
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Help Scout OAuth will send us ?code=xxxxx&state={workspaceAlias}
    const state = searchParams.get('state');

    if (state) {
      // Mock success payload
      setRedirect({ success: true, workspaceAlias: state });
      // Close the popup and let opener refresh its UI
      window.close();
    } else {
      navigate('/500', { replace: true });
    }
  }, [setRedirect, navigate, searchParams]);

  return <LoadingLayout>Connecting Help Scout…</LoadingLayout>;
};

export default HelpScoutRedirect;
